/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 9V11M12 7V11M16 8V11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 2H21M3 2V9.6C3 11.8402 3 12.9603 3.43597 13.816C3.81947 14.5686 4.43139 15.1805 5.18404 15.564C6.03968 16 7.15979 16 9.4 16H14.6C16.8402 16 17.9603 16 18.816 15.564C19.5686 15.1805 20.1805 14.5686 20.564 13.816C21 12.9603 21 11.8402 21 9.6V2M3 2H1.5M21 2H22.5M12 16V19M12 19L7 22M12 19L17 22M12 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M3 2H21V9.6C21 11.8402 21 12.9603 20.564 13.816C20.1805 14.5686 19.5686 15.1805 18.816 15.564C17.9603 16 16.8402 16 14.6 16H9.4C7.15979 16 6.03969 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V2Z"
				fill="currentColor"
			/>
			<path
				d="M3 2H21M3 2V9.6C3 11.8402 3 12.9603 3.43597 13.816C3.81947 14.5686 4.43139 15.1805 5.18404 15.564C6.03968 16 7.15979 16 9.4 16H14.6C16.8402 16 17.9603 16 18.816 15.564C19.5686 15.1805 20.1805 14.5686 20.564 13.816C21 12.9603 21 11.8402 21 9.6V2M3 2H1.5M21 2H22.5M8 9V11M12 7V11M16 8V11M12 16V19M12 19L7 22M12 19L17 22M12 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 1.25C1.58579 1.25 1.25 1.58579 1.25 2C1.25 2.41421 1.58579 2.75 2 2.75H3V9.6C3 11.8402 3 12.9603 3.43597 13.816C3.81947 14.5686 4.43139 15.1805 5.18404 15.564C6.03969 16 7.15979 16 9.4 16H11.25V18.5754L6.61413 21.3569C6.25894 21.57 6.14377 22.0307 6.35688 22.3859C6.56999 22.7411 7.03069 22.8562 7.38587 22.6431L11.25 20.3246V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V20.3246L16.6141 22.6431C16.9693 22.8562 17.43 22.7411 17.6431 22.3859C17.8562 22.0307 17.7411 21.57 17.3859 21.3569L12.75 18.5754V16H14.6C16.8402 16 17.9603 16 18.816 15.564C19.5686 15.1805 20.1805 14.5686 20.564 13.816C21 12.9603 21 11.8402 21 9.6V2.75H22C22.4142 2.75 22.75 2.41421 22.75 2C22.75 1.58579 22.4142 1.25 22 1.25H2ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V11C12.75 11.4142 12.4142 11.75 12 11.75C11.5858 11.75 11.25 11.4142 11.25 11V7C11.25 6.58579 11.5858 6.25 12 6.25ZM16 7.25C16.4142 7.25 16.75 7.58579 16.75 8V11C16.75 11.4142 16.4142 11.75 16 11.75C15.5858 11.75 15.25 11.4142 15.25 11V8C15.25 7.58579 15.5858 7.25 16 7.25ZM8 8.25C8.41421 8.25 8.75 8.58579 8.75 9V11C8.75 11.4142 8.41421 11.75 8 11.75C7.58579 11.75 7.25 11.4142 7.25 11V9C7.25 8.58579 7.58579 8.25 8 8.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3 2H21H22.5M3 2V9.6C3 11.8402 3 12.9603 3.43597 13.816C3.81947 14.5686 4.43139 15.1805 5.18404 15.564C6.03968 16 7.15979 16 9.4 16H14.6C16.8402 16 17.9603 16 18.816 15.564C19.5686 15.1805 20.1805 14.5686 20.564 13.816C21 12.9603 21 11.8402 21 9.6V5.5M3 2H1.5M8 9V11M12 7V11M16 8V11M12 16V19M12 19L7 22M12 19L17 22M12 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3 2H21M3 2V9.6C3 11.8402 3 12.9603 3.43597 13.816C3.81947 14.5686 4.43139 15.1805 5.18404 15.564C6.03968 16 7.15979 16 9.4 16H14.6C16.8402 16 17.9603 16 18.816 15.564C19.5686 15.1805 20.1805 14.5686 20.564 13.816C21 12.9603 21 11.8402 21 9.6V2M3 2H1.5M21 2H22.5M8 9V11M12 7V11M16 8V11M12 16V19M12 19L7 22M12 19L17 22M12 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M3 2H21V9.6C21 11.8402 21 12.9603 20.564 13.816C20.1805 14.5686 19.5686 15.1805 18.816 15.564C17.9603 16 16.8402 16 14.6 16H9.4C7.15979 16 6.03969 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V2Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 2C1.25 1.58579 1.58579 1.25 2 1.25H22C22.4142 1.25 22.75 1.58579 22.75 2C22.75 2.41421 22.4142 2.75 22 2.75H2C1.58579 2.75 1.25 2.41421 1.25 2ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V11C12.75 11.4142 12.4142 11.75 12 11.75C11.5858 11.75 11.25 11.4142 11.25 11V7C11.25 6.58579 11.5858 6.25 12 6.25ZM16 7.25C16.4142 7.25 16.75 7.58579 16.75 8V11C16.75 11.4142 16.4142 11.75 16 11.75C15.5858 11.75 15.25 11.4142 15.25 11V8C15.25 7.58579 15.5858 7.25 16 7.25ZM8 8.25C8.41421 8.25 8.75 8.58579 8.75 9V11C8.75 11.4142 8.41421 11.75 8 11.75C7.58579 11.75 7.25 11.4142 7.25 11V9C7.25 8.58579 7.58579 8.25 8 8.25ZM12 15.25C12.4142 15.25 12.75 15.5858 12.75 16V18.5754L17.3859 21.3569C17.7411 21.57 17.8562 22.0307 17.6431 22.3859C17.43 22.7411 16.9693 22.8562 16.6141 22.6431L12.75 20.3246V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V20.3246L7.38587 22.6431C7.03069 22.8562 6.56999 22.7411 6.35688 22.3859C6.14377 22.0307 6.25894 21.57 6.61413 21.3569L11.25 18.5754V16C11.25 15.5858 11.5858 15.25 12 15.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
